<template>
  <el-dialog title="订单操作记录" :visible.sync="dialogVisible" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-table stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
      <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell" />
      <el-table-column label="操作时间" prop="createTime" width="150" />
      <el-table-column label="备注说明" prop="remark" />
    </el-table>

    <template v-slot:footer>
      <el-button type="primary" @click="dialogClose">关　闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrderRecords } from '@/api/order'

export default {
  name: 'OrderLog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      list: []
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      getOrderRecords(this.orderId).then(response => {
        this.list = response
      }).catch(() => {})
    },
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__body {
    padding: 0;
  }
</style>
